import Vue from 'vue';

/**
 * @deprecated Use emitter instead
 */
export const EventBus = new Vue();
